import styled from 'styled-components';

export const DoohInventoryMapVolumetryStyled = styled.div`

  .doohInventoryMapVolumetry {

    &__metric {
      padding: 0 14px;

      &Value {
        display: block;
        width: 100%;
        text-align: center;
        color: ${props => props.theme.uiColors.textTitle};
        font-family: ${props => props.theme.fontSemiBold};
        font-size: ${props => props.theme.fontSizeM};
      }

      &Name {
        display: block;
        width: 100%;
        text-align: center;
        font-size: ${props => props.theme.fontSizeS};
        font-family: ${props => props.theme.fontRegular};
        color: ${props => props.theme.uiColors.textBodySoft};
      }
    }

    &__section {
      border-radius: 10px;
    }

    &__container {
      display: none;
      margin-bottom: 8px;
      
      &--show {
        display: grid;
        gap: 8px;
      }
    }

    &__section {
      color: #fff;
      background: rgba(14, 20, 24, 0.95);
      height: 54px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    &__buttonContainer {
      float: right;
    }

  }
`;
